import { bookEditingPayload } from "shared/bookEditingPayload";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import TitleInformationForm from "layouts/publish-here/components/PublishSteps/TitleInformationForm";
import { getBookForEditing, updateBook } from "services/books";

export default function EditPublication({ user }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [book, setBook] = useState(null);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    setBook(null);
    getBookForEditing(id)
      .then((result) => {
        if (active) setBook(result.book);
      })
      .catch((failure) => {
        if (active) setError(failure.message);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [id]);
  const save = async (form) => {
    setSaving(true);
    setError("");
    setNotice(null);
    try {
      const result = await updateBook(id, bookEditingPayload(form, book.version));
      setBook(result.book);
      setNotice({
        severity: result.warning ? "warning" : "success",
        text: result.warning || "Alterações salvas e sincronizadas com a loja.",
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (failure) {
      setError(failure.message);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } finally {
      setSaving(false);
    }
  };
  return (
    <DashboardLayout>
      <Box py={3}>
        <Button onClick={() => navigate("/my-publications")} disabled={saving}>
          Voltar às publicações
        </Button>
        <Typography variant="h4" mt={2}>
          Editar publicação
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Revise a ficha da obra. Identificadores, vínculo com a loja e dados extraídos do arquivo
          estão bloqueados.
        </Typography>
        {loading && <CircularProgress aria-label="Carregando publicação" />}
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {notice && (
          <Alert severity={notice.severity} sx={{ mb: 2 }}>
            {notice.text}
          </Alert>
        )}
        {book?.trayStatus === "sync_pending" && !notice && (
          <Alert severity="warning">
            Há alterações aguardando sincronização. Revise e salve novamente para tentar
            sincronizar.
          </Alert>
        )}
        {book && (
          <TitleInformationForm
            key={book.version}
            editing
            reference={book.reference}
            user={user}
            pdfInfo={book.pdf}
            paper={book.paper}
            isSaving={saving}
            onSave={save}
            onClose={() => navigate("/my-publications")}
            draft={{
              ...book,
              ...book.details,
              internalCode: book.reference,
              identificationMode: book.isbn ? "isbn" : "pso",
            }}
          />
        )}
      </Box>
    </DashboardLayout>
  );
}
